import {useMutation} from '@tanstack/react-query';
import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {AppMedError} from '../../../error/AppMedError.ts';
import {PatientInvitationsApi} from '../../../apis/PatientInvitationsApi/PatientInvitationsApi.ts';

export function useResendPatientInvitation() {
    return useMutation<void, AppMedError, string>({
        mutationKey: [QueryKeys.patientInvitations, 'resend'],
        mutationFn: (email: string) => PatientInvitationsApi.resendPatientInvitation(email),
    });
}
